export default ({ id, type }) => {
  switch (type) {
    case 'topic':
      return `/student/videos/topics/${id}`;
    case 'video':
      return `/student/videos/on-demand/${id}`;
    default:
  }
};
